import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'decimalFormat',
    standalone: false
})
export class DecimalFormatPipe implements PipeTransform {
  transform(value: number): string {
    value = Number(value);
    // Check if the number has a non-zero decimal part
    if (value % 1 !== 0) {
      // If it has a non-zero decimal part, format it with two decimal points
      return value.toFixed(2).replace(/\.?0+$/, '');
    } else {
      // If the decimal part is zero, remove it
      return value.toFixed(0);
    }
  }
}